// extracted by mini-css-extract-plugin
module.exports = {"container":"namedPatient_container__32qap","name":"namedPatient_name__140_Q","avatar":"namedPatient_avatar__jOIxK"};